import {
  ActiveConfig,
  WorkflowConfig,
  WorkflowZoneDevicesConfig,
} from '@finxone-platform/shared/sys-config-types';

export function getZoneConfig(
  workflowConfig: WorkflowConfig,
  activeConfig: ActiveConfig,
): WorkflowZoneDevicesConfig {
  return workflowConfig.permissionSections.roles.find((role) => role.name === activeConfig.activeRole)?.zones[
    activeConfig.activeZone
  ]?.canvases.subscription[activeConfig.activeCanvasSubscription] as WorkflowZoneDevicesConfig;
}
